import { useState } from 'react';
import { PencilIcon, TrashIcon, CheckIcon, XIcon } from '@heroicons/react/solid';

export default function EditableTable({data, fields, onUpdate, onDelete}) {
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState('');

  const startEdit = (row) => {
    setEditingId(row[0]);
    setEditValue(row[1]);
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditValue('');
  };

  const saveEdit = async(id) => {
    await onUpdate(id, editValue);
    setEditingId(null);
    setEditValue('');
  };

  const handleDelete = (id) => {
    if (window.confirm("Weet je zeker dat je dit product wilt verwijderen?")) {
      onDelete(id);
    }
  };

  return (
    <div className="flex flex-col">
      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  {fields.map((field, fieldIdx) => (
                    <th
                      key={fieldIdx}
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      {field}
                    </th>
                  ))}
                  <th
                    scope="col"
                    className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    ACTIES
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((row, rowIdx) => (
                  <tr key={row[0]} className={rowIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                    {/* Naam field */}
                    <td className="px-6 py-4 text-sm font-medium text-gray-900 whitespace-normal break-words">
                      {editingId === row[0] ? (
                        <input
                          type="text"
                          value={editValue}
                          onChange={(e) => setEditValue(e.target.value)}
                          className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        />
                      ) : (
                        row[1]
                      )}
                    </td>

                    {/* Action buttons */}
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <div className="flex justify-end gap-2">
                        {editingId === row[0] ? (
                          <>
                            <button
                              onClick={() => saveEdit(row[0])}
                              className="text-green-600 hover:text-green-900 transition-colors"
                              title="Opslaan"
                            >
                              <CheckIcon className="h-5 w-5" />
                            </button>
                            <button
                              onClick={cancelEdit}
                              className="text-gray-400 hover:text-gray-600 transition-colors"
                              title="Annuleren"
                            >
                              <XIcon className="h-5 w-5" />
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              onClick={() => startEdit(row)}
                              className="text-indigo-600 hover:text-indigo-900 transition-colors"
                              title="Bewerken"
                            >
                              <PencilIcon className="h-5 w-5" />
                            </button>
                            <button
                              onClick={() => handleDelete(row[0])}
                              className="text-red-600 hover:text-red-900 transition-colors"
                              title="Verwijderen"
                            >
                              <TrashIcon className="h-5 w-5" />
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
